<template>
  <div>
    <div>
      <a-button class="top_btn" type="primary" @click="()=>{  visibleForm = true; titleForm='添加文件' }"> 添加</a-button>

      <a-popconfirm
          title="此操作将永久删除, 是否继续?"
          ok-text="确定"
          cancel-text="取消"
          @confirm="confirm('')"
          @cancel="()=>{}"
          :disabled="!hasSelected"
      >
        <a-button type="primary" :disabled="!hasSelected" :loading="loading">
          删除
        </a-button>
        <span class="pv-style">列表页被访问次数：{{topCounter}}</span>
      </a-popconfirm>
      <span style="margin-left: 8px">
        <template v-if="hasSelected">
          {{ `选中 ${selectedRowKeys.length} 项` }}
        </template>
      </span>
    </div>
    <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="pagination" rowKey="id"
             :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }">

            <span slot="action" slot-scope="text, record">
        <a @click="(record)=>{visibleForm = true; titleForm='编辑文件'; editId=text.id ; }">编辑 <a-divider type="vertical"/></a>
          <a-popconfirm
              title="此操作将永久删除, 是否继续?"
              ok-text="确定"
              cancel-text="取消"
              @confirm="confirm([record.id])"
              @cancel="()=>{}"
          >
   <a>删除</a>
  </a-popconfirm>
      </span>
    </a-table>
    <NewForm :visible="visibleForm" :title="titleForm" :editId="editId"
             @changVisible=" () => { this.visibleForm = false;this.editId='';  this.getList()}  "/>

  </div>

</template>

<script>
import API from "./api";
import NewForm from "./components/newForm"
import {changStatus, removeById} from "../../../utils/utils"

const columns = [
  {
    title: "文件名称",
    dataIndex: "name",
    ellipsis: true,
    key: "name"
  },
  {
    title: "上传时间",
    dataIndex: "create_time",
    ellipsis: true,
    key: "create_time"
  },
  {
    title: "下载次数",
    dataIndex: "counter",
    ellipsis: true,
    key: "counter"
  },
  {
    title: "操作",
    key: "action",
    width: "150px",
    scopedSlots: {customRender: "action"}
  }
];
export default {
  name: 'index',
  data() {
    return {
      pagination: {
        pageNo: 1,
        pageSize: 20, // 默认每页显示数量
        onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
        onChange: this.getList.bind(this), //点击页码事件
        total: 0, //总条数
        current: 0,
        size: "small",
        showTotal: total => `共 ${total} 条`,
        showQuickJumper: true
      },
      selectedRowKeys: [], // Check here to configure the default column
      visibleForm: false,
      titleForm: "",
      loading: true,
      editId: null,
      jurisdictionId: null,
      visibleJurisdiction: false,
      data: [],
      columns,
      topCounter:0
    }
  },
  created() {
    this.$store.state.adminleftnavnum = "/Set/InquiryGarbage"; //设置左侧导航2-2 active
  },
  components: {NewForm},
  computed: {
    hasSelected() {
      return this.selectedRowKeys.length > 0;
    },
  },
  methods: {
    getList(page) {
      API.administrator.GET_LIST(page || 1).then(res => {
        this.data = res.data.data.list.data
        this.topCounter = res.data.data.counter
        this.pagination.total = res.data.data.list.total
        this.pagination.pageSize = res.data.data.list.per_page
        this.pagination.current = res.data.data.list.current_page
        this.loading = false
      })
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    onChange(row) {
      let Json = {id: row.id, status: row.status == 0 ? 1 : 0}
      changStatus(API.administrator.CHANG_STATUS, [Json]).then(res => {
        if (res == true) {
          this.getList()
        }
      })
    },
    confirm(id) {
      if (id == '') {
        id = this.selectedRowKeys
      }
      removeById(API.administrator.DELE, id).then(res => {
        if (res == true) {
          this.getList()
          this.selectedRowKeys = []
        }
      })
    },
  },
  mounted() {
    this.getList()
  }

}
</script>
<style scoped>
.pv-style {
  display: inline-block;
  float: right;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
}
</style>
